export const ExternalTransactionType = {
  DEPOSITS_PENDING: 'DEPOSITS_PENDING',
  DEPOSITS_SUCCESSFUL: 'DEPOSITS_SUCCESSFUL',
  DEPOSITS_FAILED: 'DEPOSITS_FAILED',
  WITHDRAWALS_PENDING: 'WITHDRAWALS_PENDING',
  WITHDRAWALS_SUCCESSFUL: 'WITHDRAWALS_SUCCESSFUL',
  WITHDRAWALS_FAILED: 'WITHDRAWALS_FAILED',
  BETS_UNSETTLED: 'BETS_UNSETTLED',
  BETS_VOIDED: 'BETS_VOIDED',
  BETS_WON: 'BETS_WON',
  BETS_LOST: 'BETS_LOST',
} as const;

export type ExternalTransactionKind = typeof ExternalTransactionType[keyof typeof ExternalTransactionType]
